export default __webpack_public_path__ + "static/media/chatter.d58c64ee.gif";